/**
 * "lat, lng" as typed or pasted into a coordinate field: extra spaces and
 * repeated commas are folded, so "1.28 ,, 103.86" reads as "1.28, 103.86".
 */
export const normalizeCoordinate = (value: string) =>
  value.replace(/\s+/g, ' ').trim().replace(/,+/g, ',')

/**
 * The typed pair, or null when it is not a usable coordinate: exactly two
 * numbers, latitude within ±90 and longitude within ±180. The strings are
 * returned as typed, so no precision is lost on the way to the map.
 */
export const parseCoordinates = (
  value: string,
): { latitude: string; longitude: string } | null => {
  const parts = normalizeCoordinate(value).split(',')
  if (parts.length !== 2) return null
  const [latitude, longitude] = parts.map((part) => part.trim())
  // Number(), not parseFloat: "1.2abc" is a typo, not 1.2.
  const lat = latitude === '' ? NaN : Number(latitude)
  const lng = longitude === '' ? NaN : Number(longitude)
  if (!Number.isFinite(lat) || lat < -90 || lat > 90) return null
  if (!Number.isFinite(lng) || lng < -180 || lng > 180) return null
  return { latitude, longitude }
}
